import { render, staticRenderFns } from "./imageDetail.vue?vue&type=template&id=4ae2f5ed&scoped=true"
import script from "./imageDetail.vue?vue&type=script&lang=js"
export * from "./imageDetail.vue?vue&type=script&lang=js"
import style0 from "./imageDetail.vue?vue&type=style&index=0&id=4ae2f5ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae2f5ed",
  null
  
)

export default component.exports